/* eslint-disable camelcase */
import * as Sentry from '@sentry/vue'
import swal from 'sweetalert2'
import config from '../../config'
import router from '../../router/router'
import store from '../../store/store'
import { resetStateToDefault } from '../../utils'
import { tratarErroColetor, validarStatusColetor, tratarErroLoginColetor } from './utils'
import { Http } from 'vue-resource'
import {
  gerarUrlColetores,
  gerarUrlEmpregados,
  gerarUrlPerfisDeColetor,
  gerarUrlLocaisDeTrabalho,
  gerarUrlColetor,
  gerarUrlCriarColetorColetivo,
  gerarUrlCriarColetorPessoal,
  gerarUrlCriarColetorPessoalSSO,
  gerarUrlRestaurarColetor,
  gerarUrlLogarColetor,
  gerarUrlRenovarChaveAcesso
} from '../../api'
import i18n from '../../locales/i18n'
import { formatarObjetoWebParaSentry } from '../../sentry.ts'

function defaultState () {
  return {
    loading: false,
    coletores: {
      lista: [],
      selecionado: null,
      filtro: '',
      total: null,
      faltaColetores: false,
      pagina: 0
    },
    perfisDeColetor: {
      lista: [],
      selecionado: null,
      perfilPadrao: null,
      total: null,
      faltaPerfis: false,
      pagina: 0
    },
    restaurarColetor: {
      id: null,
      locais: null,
      modo: null,
      nome: null,
      perfil: null,
      status: null,
      todos_os_locais: null
    },
    criarColetor: {
      nome: null,
      modo: '',
      ehFuncionario: null,
      locais: {
        filtro: '',
        lista: [],
        selecionado: []
      },
      empregados: {
        filtro: '',
        foiFiltrado: false,
        lista: [],
        selecionado: {},
        total: null,
        faltaEmpregados: false,
        pagina: 0
      }
    },
    tentativasLogin: 0
  }
}

const getters = {
  coletoresFiltrados (state) {
    const temFiltro = state.coletores.filtro
    if (temFiltro) {
      const filtro = state.coletores.filtro.toLowerCase()
      return state.coletores.lista.filter(coletor => coletor.nome.toLowerCase().includes(filtro))
    }
    return state.coletores.lista
  },
  empregadoSelecionado (state) {
    if (state.criarColetor.ehFuncionario) {
      // Quando for empregado, significa que a API vai retornar somente 1 funcionário, logo,
      // seleciono o primeiro e unico item da lista
      return state.criarColetor.empregados.selecionado.id
    }
    return state.criarColetor.empregados.selecionado.id
  },
  locaisDeTrabalhoIdENome (state) {
    const locais = state.criarColetor.locais.lista.map(({id, nome}) => ({id, nome}))
    return locais
  }
}

const mutations = {
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  loading (state, load) {
    state.loading = load
  },
  // COLETORES
  atribuiColetores (state, { lista, selecionado, total }) {
    if (lista) {
      if (state.coletores.lista.length) {
        state.coletores.lista.push(...lista)
        return
      }
      state.coletores.lista = lista
    }
    if (selecionado) state.coletores.selecionado = selecionado
    if (total) state.coletores.total = total
  },
  atribuiFiltroColetor (state, filtro) {
    state.coletores.filtro = filtro
  },
  atribuiColetorSelecionado (state, selecao) {
    state.coletores.selecionado = selecao
  },
  coletoresPaginaEFaltaColetores (state) {
    const total = state.coletores.total
    const coletoresCarregados = state.coletores.lista.length

    if (coletoresCarregados === total) {
      state.coletores.faltaColetores = false
    }

    if (coletoresCarregados < total) {
      state.coletores.pagina++
      state.coletores.faltaColetores = true
    }
  },
  // RESTAURAR COLETOR
  atribuiRestaurarColetor (state, coletor) {
    state.restaurarColetor = coletor
  },
  atribuiNomeRestaurarColetor (state, nome) {
    state.restaurarColetor.nome = nome
  },
  atribuiLocaisRestaurarColetor (state, locais) {
    state.restaurarColetor.locais = locais
  },
  // PERFIL COLETOR
  atribuiPerfisDeColetor (state, { lista, selecionado, total, perfilPadrao }) {
    if (lista) {
      if (state.perfisDeColetor.lista.length) {
        state.perfisDeColetor.lista.push(...lista)
        return
      }
      state.perfisDeColetor.lista = lista
    }
    if (perfilPadrao) state.perfisDeColetor.perfilPadrao = perfilPadrao
    if (selecionado) state.perfisDeColetor.selecionado = selecionado
    if (total) state.perfisDeColetor.total = total
  },
  atribuiPerfilDeColetorSelecionado (state, perfil) {
    state.perfisDeColetor.selecionado = perfil
  },
  perfisDeColetorPaginaEFaltaPerfis (state) {
    const total = state.perfisDeColetor.total
    const perfisCarregados = state.perfisDeColetor.lista.length

    if (perfisCarregados === total) {
      state.perfisDeColetor.faltaPerfis = false
    }

    if (perfisCarregados < total) {
      state.perfisDeColetor.pagina++
      state.perfisDeColetor.faltaPerfis = true
    }
  },
  // CRIAR COLETOR
  atribuiNomeCriarColetor (state, nome) {
    state.criarColetor.nome = nome
  },
  atribuiModoCriarColetor (state, modo) {
    state.criarColetor.modo = modo
  },
  atribuiEhFuncionarioCriarColetor (state, ehFuncionario) {
    state.criarColetor.ehFuncionario = ehFuncionario
  },
  atribuiLocaisCriarColetor (state, { lista, selecionado, filtro }) {
    if (lista) {
      if (state.criarColetor.locais.lista.length) {
        state.criarColetor.locais.lista.push(...lista)
        return
      }
      state.criarColetor.locais.lista = lista
    }
    if (selecionado) state.criarColetor.locais.selecionado = selecionado
    if (filtro || filtro === '') state.criarColetor.locais.filtro = filtro
  },
  atribuiEmpregadosCriarColetor (state, { selecionado, total, filtro, foiFiltrado, pagina, faltaEmpregados }) {
    if (selecionado) state.criarColetor.empregados.selecionado = selecionado
    if (total) state.criarColetor.empregados.total = total
    if (filtro || filtro === '') state.criarColetor.empregados.filtro = filtro
    if (foiFiltrado || foiFiltrado === false) state.criarColetor.empregados.foiFiltrado = foiFiltrado
    if (pagina || pagina === 0) state.criarColetor.empregados.pagina = pagina
    if (faltaEmpregados || faltaEmpregados === false) state.criarColetor.empregados.faltaEmpregados = faltaEmpregados
  },
  atribuiEmpregadosListaCriarColetor (state, lista) {
    if (!lista.length) {
      state.criarColetor.empregados.lista.length = lista
      return
    }
    if (state.criarColetor.empregados.lista.length && !state.criarColetor.empregados.filtro) {
      state.criarColetor.empregados.lista.push(...lista)
      return
    }
    state.criarColetor.empregados.lista = lista
  },
  criarColetorPaginaEFaltaEmpregados (state) {
    const total = state.criarColetor.empregados.total
    const empregadosCarregados = state.criarColetor.empregados.lista.length

    if (empregadosCarregados === total) {
      state.criarColetor.empregados.faltaEmpregados = false
    }

    if (empregadosCarregados < total) {
      state.criarColetor.empregados.pagina++
      state.criarColetor.empregados.faltaEmpregados = true
    }
  },
  atribuiTentativasLogin (state, tentativas) {
    state.tentativasLogin = tentativas
  }
}

const actions = {
  async buscarColetores ({ commit, dispatch }) {
    const parametroInicial = {
      'ordenar-por': 'asc.nome',
      'tipo_de_acesso': 'diferente.SSO',
      'apenas-restauraveis': true,
      natureza: 'igual.BATE_PONTO_WEB',
      pagina: 0,
      'por-pagina': 10
    }
    try {
      const responseInicial = await Http.get(gerarUrlColetores(), {params: parametroInicial})
      const { total } = responseInicial.body

      if (total === 0) {
        dispatch('buscarLocaisDeTrabalho')
        dispatch('buscarPerfisDeColetor')
        dispatch('buscarEmpregados')
        router.push({ name: 'criarColetor' })
        return
      }

      if (total <= 1000) {
        const paramMenorMil = {
          'ordenar-por': 'asc.nome',
          'tipo_de_acesso': 'diferente.SSO',
          'apenas-restauraveis': true,
          pagina: 0,
          natureza: 'igual.BATE_PONTO_WEB',
          'por-pagina': total
        }

        const responseFinal = await Http.get(gerarUrlColetores(), {params: paramMenorMil})
        const { itens } = responseFinal.body

        commit('atribuiColetores', { lista: itens })
        commit('register/logando', false, {root: true})
        dispatch('buscarLocaisDeTrabalho')
        dispatch('buscarPerfisDeColetor')
        dispatch('buscarEmpregados')
        router.push({ name: 'criarColetor' })
        return
      }

      if (total > 1000) {
        let coletoresBuscados = 0
        let pagina = 0

        while (coletoresBuscados < total) {
          const parametroFinal = {
            'ordenar-por': 'asc.nome',
            natureza: 'igual.BATE_PONTO_WEB',
            'apenas-restauraveis': true,
            'tipo_de_acesso': 'diferente.SSO',
            pagina: pagina++,
            'por-pagina': 1000
          }
          const responseFinal = await Http.get(gerarUrlColetores(), {params: parametroFinal})

          coletoresBuscados += 1000
          const { itens } = responseFinal.body
          commit('atribuiColetores', { lista: itens })
        }
        commit('register/logando', false, {root: true})
        dispatch('buscarLocaisDeTrabalho')
        dispatch('buscarPerfisDeColetor')
        dispatch('buscarEmpregados')
        router.push({ name: 'criarColetor' })
      }
    } catch (e) {
      commit('register/logando', false, {root: true})
      tratarErroColetor(e)
    }
  },
  async buscarColetorPorId ({ commit, state }) {
    try {
      const response = await Http.get(gerarUrlColetor(state.coletores.selecionado))
      const { modo, locais } = response.body

      if (modo === 'PESSOAL') {
        commit('atribuiRestaurarColetor', response.body)
        return
      }

      const locaisTrabalho = locais ? locais.map(({id, nome}) => ({id, nome})) : null

      commit('atribuiRestaurarColetor', {...response.body, locais: locaisTrabalho})
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async buscarPerfisDeColetor ({ commit, state }) {
    const parametros = {
      'ordenar-por': 'asc.nome',
      tipo: 'igual.BATE_PONTO_WEB',
      pagina: state.perfisDeColetor.pagina,
      'por-pagina': 100
    }
    try {
      commit('loading', true)
      const respose = await Http.get(gerarUrlPerfisDeColetor(), {params: parametros})
      const { itens, total } = respose.body
      const perfilPadrao = itens.find(perfil => perfil.padrao)

      commit('atribuiPerfisDeColetor', { lista: itens, total, perfilPadrao })
      commit('perfisDeColetorPaginaEFaltaPerfis')
    } catch (e) {
      tratarErroColetor(e)
    }
    commit('loading', false)
  },
  async buscarLocaisDeTrabalho ({ commit }) {
    const parametroInicial = {
      pagina: 0,
      'por-pagina': 10,
      'ordenar-por': 'asc.nome'
    }
    try {
      const responseInicial = await Http.get(gerarUrlLocaisDeTrabalho(), {params: parametroInicial})

      if (responseInicial.status === 204) {
        commit('atribuiEhFuncionarioCriarColetor', true)
        return
      }

      const { total } = responseInicial.body

      if (total === 0) {
        const erro =
          new Error(i18n.t('componentes.coletor.state.actions.erroSemLocalDeTrabalho'))

        throw erro
      }

      if (total <= 1000) {
        const paramMenorMil = {
          pagina: 0,
          'por-pagina': total,
          'ordenar-por': 'asc.nome'
        }

        const responseFinal = await Http.get(gerarUrlLocaisDeTrabalho(), {params: paramMenorMil})
        const { itens } = responseFinal.body
        commit('atribuiLocaisCriarColetor', { lista: itens })
        commit('atribuiEhFuncionarioCriarColetor', false)
        return
      }

      if (total > 1000) {
        let locaisBuscados = 0
        let pagina = 0

        while (locaisBuscados < total) {
          const paramMaiorMil = {
            pagina: pagina++,
            'por-pagina': 1000,
            'ordenar-por': 'asc.nome'
          }

          locaisBuscados += 1000
          const responseFinal = await Http.get(gerarUrlLocaisDeTrabalho(), {params: paramMaiorMil})
          const { itens } = responseFinal.body
          commit('atribuiLocaisCriarColetor', { lista: itens })
          commit('atribuiEhFuncionarioCriarColetor', false)
        }
      }
    } catch (e) {
      if (e.status === 400 && e.body.detail.includes('Sem permissão para listar locais e cadastrar coletor COLETIVO.')) {
        commit('atribuiEhFuncionarioCriarColetor', true)
        return
      }
      tratarErroColetor(e)
    }
  },
  async buscarEmpregados ({ commit, state }) {
    try {
      const foiFiltrado = state.criarColetor.empregados.foiFiltrado
      const temFiltro = state.criarColetor.empregados.filtro

      if (foiFiltrado && !temFiltro) {
        commit('atribuiEmpregadosCriarColetor', { foiFiltrado: false })
        commit('atribuiEmpregadosListaCriarColetor', [])
      }

      if (temFiltro) {
        const parametro = {
          nome: `contem.${state.criarColetor.empregados.filtro}`,
          pagina: 0,
          'por-pagina': 20,
          'ordenar-por': 'asc.nome'
        }
        commit('atribuiEmpregadosListaCriarColetor', [])
        const response = await Http.get(gerarUrlEmpregados(), {params: parametro})
        const { itens } = response.body
        commit('atribuiEmpregadosListaCriarColetor', itens)
        commit('atribuiEmpregadosCriarColetor', { foiFiltrado: true, pagina: 0, faltaEmpregados: false })
      } else {
        const parametro = {
          pagina: state.criarColetor.empregados.pagina,
          'por-pagina': 20,
          'ordenar-por': 'asc.nome'
        }
        const response = await Http.get(gerarUrlEmpregados(), {params: parametro})
        const { itens, total } = response.body

        if (total === 0) {
          const erro =
            new Error(i18n.t('componentes.coletor.state.actions.erroSemEmpregadoCadastrado'))
          throw erro
        }

        if (!itens) {
          commit('atribuiEmpregadosCriarColetor', {selecionado: response.body})
          return
        }
        commit('atribuiEmpregadosCriarColetor', { total })
        commit('atribuiEmpregadosListaCriarColetor', itens)
        commit('criarColetorPaginaEFaltaEmpregados')
      }
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async restaurarColetor ({ commit, state, dispatch }) {
    let parametro
    if (state.restaurarColetor.modo === 'COLETIVO') {
      parametro = {
        nome: state.restaurarColetor.nome,
        locais: state.restaurarColetor.locais ? state.restaurarColetor.locais.map(local => local.id) : [],
        todos_os_locais: state.restaurarColetor.todos_os_locais,
        implementacao: {
          natureza: 'BATE_PONTO_WEB',
          plataforma_info: {
            user_agent: navigator.userAgent
          },
          versao: config.version
        }
      }
    } else {
      parametro = {
        nome: state.restaurarColetor.nome,
        implementacao: {
          natureza: 'BATE_PONTO_WEB',
          plataforma_info: {
            user_agent: navigator.userAgent
          },
          versao: config.version
        }
      }
    }

    try {
      commit('loading', true)

      const response = await Http.post(gerarUrlRestaurarColetor(state.coletores.selecionado), parametro)
      const { atualizado, chave_do_dispositivo } = response.body

      if (state.restaurarColetor.modo === 'COLETIVO') {
        commit('tipoColetor', 'Coletivo', {root: true})
      } else {
        commit('tipoColetor', 'Pessoal', {root: true})
      }

      if (response.status === 200) {
        commit('coletorId', atualizado, {root: true})
        commit('chaveDispositivo', chave_do_dispositivo, {root: true})
        dispatch('renovarChaveAcesso')
      }
    } catch (e) {
      if (
        e.status === 400 &&
        (
          e.body.detail === 'Coletor não aprovado' ||
          e.body.detail === 'Coletor com aprovação pendente'
        )
      ) {
        commit('coletorId', state.coletores.selecionado, {root: true})
        validarStatusColetor(e)
        return
      }
      tratarErroColetor(e)
    }
    commit('loading', false)
  },
  async criarColetorColetivo ({ commit, state, dispatch }) {
    const considerarTodosLocais = state.criarColetor.modo === 'todos'
    const locais = !considerarTodosLocais ? state.criarColetor.locais.selecionado.map(local => local.id) : []
    const parametros = {
      nome: state.criarColetor.nome,
      implementacao: {
        natureza: 'BATE_PONTO_WEB',
        plataforma_info: {
          user_agent: navigator.userAgent
        },
        versao: config.version
      },
      perfil_id: state.perfisDeColetor.selecionado.id,
      locais_id: locais,
      todos_os_locais: considerarTodosLocais
    }
    try {
      const response = await Http.post(gerarUrlCriarColetorColetivo(), parametros)
      const { criado, chave_do_dispositivo } = response.body
      if (response.status === 201) {
        swal({ type: 'success', text: i18n.t('componentes.coletor.state.actions.criarColetor.texto') })
        commit('chaveDispositivo', chave_do_dispositivo, {root: true})
        commit('coletorId', criado, {root: true})
        commit('tipoColetor', 'Coletivo', {root: true})
        dispatch('renovarChaveAcesso')
      }
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async criarColetorPessoal ({ commit, state, dispatch, getters }) {
    const parametrosFuncionario = {
      nome: state.criarColetor.nome,
      implementacao: {
        natureza: 'BATE_PONTO_WEB',
        plataforma_info: {
          user_agent: navigator.userAgent
        },
        versao: config.version
      },
      empregado_id: getters.empregadoSelecionado
    }
    const parametros = {
      ...parametrosFuncionario,
      perfil_id: state.perfisDeColetor.selecionado ? state.perfisDeColetor.selecionado.id : ''
    }
    try {
      let response

      if (state.criarColetor.ehFuncionario) {
        response = await Http.post(gerarUrlCriarColetorPessoal(), parametrosFuncionario)
      } else {
        response = await Http.post(gerarUrlCriarColetorPessoal(), parametros)
      }

      const { criado, chave_do_dispositivo } = response.body
      if (response.status === 201) {
        swal({ type: 'success', text: i18n.t('componentes.coletor.state.actions.criarColetor.texto') })
        commit('chaveDispositivo', chave_do_dispositivo, {root: true})
        commit('coletorId', criado, {root: true})
        commit('tipoColetor', 'Pessoal', {root: true})
        dispatch('renovarChaveAcesso')
      }
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async criarColetorSSO ({ commit, dispatch }) {
    Sentry.captureEvent({
      message: 'Criar coletor SSO (clear)',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })

    window.localStorage.clear()
    try {
      const parametros = {
        implementacao: {
          natureza: 'BATE_PONTO_WEB',
          plataforma_info: {
            user_agent: navigator.userAgent
          },
          versao: config.version
        }
      }
      const res = await Http.post(gerarUrlCriarColetorPessoalSSO(), parametros)
      const { chave_do_dispositivo, criado } = await res.body
      commit('chaveDispositivo', chave_do_dispositivo, {root: true})
      commit('coletorId', criado, {root: true})
      commit('tipoColetor', 'Pessoal', {root: true})

      dispatch('renovarChaveAcessoSSO')
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async renovarChaveAcesso ({commit, dispatch}) {
    const parametros = {
      coletor_id: store.state.accessData.coletor.coletorId,
      chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo
    }
    try {
      const rotaAnterior = store.state.rotaAnterior.name
      const response = await Http.post(gerarUrlRenovarChaveAcesso(), parametros)
      const { chave_do_dispositivo, cliente_id } = response.body
      if (response.status === 200) {
        if (!rotaAnterior) {
          swal({ type: 'success', text: i18n.t('componentes.coletor.state.actions.renovarChaveAcesso.coletorAprovado.texto') })
          commit('chaveDispositivo', chave_do_dispositivo, {root: true})
          commit('clientId', cliente_id, {root: true})
          commit('coletorPendente', false, {root: true})
          dispatch('logarColetor', {})
          return
        }
        if (rotaAnterior === 'listaColetores') {
          swal({ type: 'success', text: i18n.t('componentes.coletor.state.actions.renovarChaveAcesso.coletorRestaurado.texto') })
          commit('chaveDispositivo', chave_do_dispositivo, {root: true})
          commit('clientId', cliente_id, {root: true})
          commit('coletorPendente', false, {root: true})
          dispatch('logarColetor', {})
          return
        }
        if (rotaAnterior === 'criarColetor') {
          commit('chaveDispositivo', chave_do_dispositivo, {root: true})
          commit('coletorPendente', false, {root: true})
          commit('clientId', cliente_id, {root: true})
          dispatch('logarColetor', {})
          return
        }
      }
    } catch (e) {
      if (
        e.status === 400 &&
        (
          e.body.detail === 'Coletor não aprovado' ||
          e.body.detail === 'Coletor com aprovação pendente'
        )
      ) {
        validarStatusColetor(e)
        return
      }
      tratarErroColetor(e)
    }
  },
  async logarColetor ({rootState, commit, dispatch}, {
    parametrosRecaptcha = null,
    tempoParaFazerRequisicao = 5000,
    urlBaseParaRetry = false
  }) {
    const parametrosPadrao = {
      coletor_id: store.state.accessData.coletor.coletorId,
      chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo,
      cliente_id: store.state.accessData.coletor.clientId
    }
    try {
      let response

      if (parametrosRecaptcha) {
        response = await Http.post(gerarUrlLogarColetor(), parametrosRecaptcha, {
          timeout: tempoParaFazerRequisicao,
          urlBaseParaRetry: urlBaseParaRetry
        })
      } else {
        response = await Http.post(gerarUrlLogarColetor(), parametrosPadrao, {
          timeout: tempoParaFazerRequisicao,
          urlBaseParaRetry: urlBaseParaRetry
        })
      }

      const { access_token } = response.body

      if (!access_token) {
        Sentry.captureException({
          message: `Não recebeu valor do token de acesso ao logar no coletor. Token: ${access_token}`
        })
      }

      dispatch('iniciarWorkeRenovacaoToken')
      if (response.status === 200) {
        commit('atribuiTentativasLogin', 0)
        commit('tokenColetor', access_token, {root: true})
        commit('resetState')

        if (router.history.current.name === 'sincronizador') {
          // Fluxo acionado quando estamos renovando o token do coletor
          // Uma vez renovado, fazemos a sincronização do usuário
          const tentouSincronizarPin = rootState.sincronizador.erroSincronizarPin
          await dispatch('sincronizador/fazerSincronizacaoWeb', {}, {root: true})

          if (tentouSincronizarPin) {
            await dispatch('sincronizador/fazerSincronizacaoUsuario', {}, {root: true})
            commit('sincronizador/atribuiErroSincronizarPin', false, {root: true})
          }
          return
        }

        router.push({name: 'sincronizador'})
      }
    } catch (e) {
      tratarErroLoginColetor(e)
    }
  },
  async renovarChaveAcessoSSO ({commit, dispatch}) {
    const parametros = {
      coletor_id: store.state.accessData.coletor.coletorId,
      chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo
    }
    try {
      const response = await Http.post(gerarUrlRenovarChaveAcesso(), parametros)
      const { chave_do_dispositivo, cliente_id } = response.body

      commit('chaveDispositivo', chave_do_dispositivo, {root: true})
      commit('clientId', cliente_id, {root: true})
      dispatch('logarColetorSSO', {})
    } catch (e) {
      tratarErroColetor(e)
    }
  },
  async logarColetorSSO ({commit, dispatch}, {
    parametrosRecaptcha = null,
    tempoParaFazerRequisicao = 5000,
    urlBaseParaRetry = false
  }) {
    const parametrosPadrao = {
      coletor_id: store.state.accessData.coletor.coletorId,
      chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo,
      cliente_id: store.state.accessData.coletor.clientId
    }
    try {
      let response

      if (parametrosRecaptcha) {
        response = await Http.post(gerarUrlLogarColetor(), parametrosRecaptcha, {
          timeout: tempoParaFazerRequisicao,
          urlBaseParaRetry: urlBaseParaRetry
        })
      } else {
        response = await Http.post(gerarUrlLogarColetor(), parametrosPadrao, {
          timeout: tempoParaFazerRequisicao,
          urlBaseParaRetry: urlBaseParaRetry
        })
      }

      const { access_token } = response.body
      dispatch('iniciarWorkeRenovacaoToken')
      commit('tokenColetor', access_token, {root: true})
      commit('atribuiTentativasLogin', 0)
      dispatch('sincronizador/fazerSincronizacaoWebSSO', {}, {root: true})
    } catch (e) {
      tratarErroLoginColetor(e, true)
    }
  },
  iniciarWorkeRenovacaoToken ({ dispatch }) {
    const {origin, pathname} = window.location
    const worker = new Worker(`${origin}${pathname}js/renovacaoTokenColetor.js`)

    worker.addEventListener('message', (e) => {
      const possuiRecaptcha = store.getters['sincronizador/coletorComRecaptcha']
      // Caso possuir recaptcha, não renovamos o token em segundo plano pois dependemos do token do recaptcha ativo
      if (possuiRecaptcha) return
      dispatch('renovarTokenColetorSemRecaptcha')
    })

    worker.postMessage(true)
  },
  async renovarTokenColetorSemRecaptcha ({ commit }) {
    const parametros = {
      coletor_id: store.state.accessData.coletor.coletorId,
      chave_do_dispositivo: store.state.accessData.coletor.chaveDispositivo,
      cliente_id: store.state.accessData.coletor.clientId
    }

    try {
      const response = await Http.post(gerarUrlLogarColetor(), parametros)

      const { access_token } = response.body

      if (!access_token) {
        Sentry.captureException({
          message: `Não renovou TokenColetorSemRecaptcha. Token: ${access_token}`
        })
      }

      commit('tokenColetor', access_token, {root: true})
    } catch (e) {
      console.error(e)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  actions,
  mutations
}
